import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Box, Typography } from '@material-ui/core'
import { OutlinedButton, Cards, TableOutline, Popup } from '../../elements'
import { vppService, programService } from '../../Services'
import { SORTORDER } from '../../utils/constants'
import { Loader, AppButton, DisplayMessage, Breadcrumb } from '../../Components'
import { useStyles } from './style'
import { tableHeadings } from './constants'
import { SUCCESS } from '../../utils/messageTypes'
import { getProgramById } from '../../AppRedux/actions/Programs'

function Vpp(props) {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [sortBy, setSortBy] = useState('')
  const [headings, setHeadings] = useState(tableHeadings(classes))
  const [vppList, setVppList] = useState([])
  const [tableCount, setTableCount] = useState(0)
  const [showPopup, setPopup] = useState(false)
  const [accountId, setAccountId] = useState('')
  const [programList, setProgramList] = useState([])
  const [programId, setProgramId] = useState('')
  const [showMessage, setShowMessage] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState(SUCCESS)
  const [sortOrder, setSortOrder] = useState('')

  useEffect(() => {
    setShowMessage(_.get(props.location, 'showMessage', false))
    setMessage(_.get(props.location, 'message', ''))
    setMessageType(_.get(props.location, 'messageType', SUCCESS))
  }, [props.location])

  useEffect(() => {
    const id = _.get(props.match.params, 'programs_id', '')
    setProgramId(id)
    if (props.accountId && id && id !== props.programId) {
      props.getProgramById({
        accountId: props.accountId,
        programId: id
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params, props.programId, props.accountId])

  useEffect(() => {
    setPage(1)
  }, [rowsPerPage, headings])

  useEffect(() => {
    setHeadings(tableHeadings(classes, props.isAdmin, props.isViewOnly))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isAdmin, props.isViewOnly])

  useEffect(() => {
    const accountId = _.get(props.currentUser, 'account_id', '')

    if (accountId) {
      setLoading(true)
      programService.getAllAvailablePrograms(accountId)
        .then(response => {
          const programs = response ? response.filter(obj => obj.is_active) : []
          setProgramList(programs)
          setLoading(false)
        })
        .catch(error => { setLoading(false) })
    }
    setAccountId(accountId)
  }, [props.currentUser])

  useEffect(() => {
    setLoading(true)
    accountId && getAllVpp(page, rowsPerPage, sortBy, sortOrder)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId, programId])

  const successCb = (response) => {
    const vppListData = []
    const { vpp_list, total_count } = response

    _.isArray(vpp_list) && vpp_list.forEach((obj) => {
      const query = _.get(obj, 'query', {})
      const tags = _.get(query, 'tags', {})

      vppListData.push([
        {
          id: 'name',
          value: _.get(obj, 'name', ''),
          vppId: _.get(obj, 'id', ''),
          programList,
          className: `${classes.vppName} ${_.isEmpty(tags) ? classes.allSystems : ''}`,
          handleClick: (selected) => {
            props.history.push({
              pathname: `vpp/${_.get(selected, 'vppId', '')}`,
              state: {
                programList: _.get(selected, 'programList', [])
              }
            })
          }
        },
        {
          id: 'programName',
          value: _.get(obj, 'program_name', ''),
          className: _.isEmpty(tags) ? classes.allSystems : '',
        },
        {
          id: 'totSystems',
          value: _.get(obj, 'total_systems', ''),
          className: `${_.isEmpty(tags) ? classes.allSystems : ''} ${classes.tableRightAlign}`,
        },
        {
          id: 'batteryCapacity',
          value: _.get(obj, 'battery_capacity', ''),
          className: `${_.isEmpty(tags) ? classes.allSystems : ''} ${classes.tableRightAlign}`,
        },
        {
          id: 'totpower',
          value: _.get(obj, 'total_power', ''),
          className: `${_.isEmpty(tags) ? classes.allSystems : ''} ${classes.tabelLastCol}`,
        }
      ])
    })

    setVppList(vppListData || [])
    setTableCount(total_count || 0)
    setLoading(false)
  }

  const getAllVpp = (pageNum, pageSize, sortColBy, sortOrderType) => {
    if (programId) {
      vppService.getAllProgramVppView({ page: pageNum - 1, size: pageSize, sortBy: sortColBy, programId, sort_order: sortOrderType }, accountId)
        .then(response => {
          successCb(response)
        })
        .catch(error => {
          setLoading(false)
        })
    } else {
      vppService.getAllAccountVpp({ page: pageNum - 1, size: pageSize, sortBy: sortColBy, sort_order: sortOrderType }, accountId)
        .then(response => {
          successCb(response)
        })
        .catch(error => {
          setLoading(false)
        })
    }
  }

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    setPage(1)
    setLoading(true)
    getAllVpp(1, value, sortBy, sortOrder)
  }

  const handleCreateVpp = () => {
    if (!_.isEmpty(programList)) {
      const path = `vpp/create-new-vpp`
      props.history.push({
        pathname: path
      })
    } else {
      setPopup(true)
    }
  }

  const renderPopupContent = () => {
    return (
      <Box className={classes.popWrapper}>
        <Typography className={classes.popText}>You need an approved program to create a virtual power plant. Please submit a request to create a new program.</Typography>
        <AppButton text='Ok' className={classes.ackButton} onClick={() => setPopup(false)} />
      </Box>
    )
  }

  const handleSortData = (sortedObj) => {
    const modifiedObj = _.cloneDeep(headings)
    modifiedObj.forEach((obj, index) => {
      if (obj.id === sortedObj.id && obj.isSortable) {
        modifiedObj[index].sortOrder = obj.sortOrder === SORTORDER.ASC ? SORTORDER.DESC : SORTORDER.ASC
      } else {
        modifiedObj[index].sortOrder = SORTORDER.ASC
      }
    })
    const selectedObj = modifiedObj.find(obj => sortedObj.id === obj.id)
    const selectedTypeAsc = selectedObj.sortOrder === SORTORDER.ASC ? SORTORDER.ASC : SORTORDER.DESC

    setSortOrder(selectedTypeAsc)
    setLoading(true)
    setPage(1)
    setSortBy(sortedObj.id)
    getAllVpp(1, rowsPerPage, selectedObj.id || '', selectedTypeAsc)
    setHeadings(modifiedObj)
  }

  const handlePageChange = (newPage) => {
    setPage(newPage)
    getAllVpp(newPage, rowsPerPage, sortBy, sortOrder)
  }

  const renderCardContent = () => {
    return (
      <Box>
        <Box className={classes.tableWrapper}>
          <TableOutline
            tableHeadings={headings}
            tableData={vppList}
            totalElement={tableCount}
            page={page}
            rowsPerPage={rowsPerPage}
            handleChangePage={handlePageChange}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleSortData={handleSortData}
            pagination
            loading={loading}
          />
          <Typography className={classes.disclaimer}>*All Systems is the default Virtual Power Plant that contains all enrolled systems of the program. This VPP cannot be modified.</Typography>
        </Box>
      </Box>
    )
  }

  const renderNav = () => {
    if (programId) {
      const obj = {}
      obj[_.get(props.programDetails, 'program_name_admin_ui', '')] = `/programs/${programId}`
      return [{ 'Home': '/' }, { 'Programs': '/programs' }, obj, { 'Virtual Power Plants': '' }]
    }

    return [{ 'Home': '/' }, { 'Virtual Power Plants': '' }]
  }

  return (
    <Box>
      <Breadcrumb value={renderNav()} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Virtual Power Plants</Typography>
        <Box className={classes.buttonWrapper} style={{width: props.isSuperAdmin ?  "470px" : ""}}>
          {!props.isViewOnly && props.isAdmin && <OutlinedButton label='create new virtual power plant' onClick={handleCreateVpp} />}
          {!props.isViewOnly && props.isSuperAdmin && <OutlinedButton label='FORECAST GRAPHS' onClick={() => props.history.push('/vpp/forecast-graphs')} />}
        </Box>
      </Box>
      <Cards className={classes.cardWrapper} children={renderCardContent()} />
      <Popup
        open={showPopup}
        handleClose={() => setPopup(false)}
        content={renderPopupContent()}
      />
      <Loader loading={loading} />
      <DisplayMessage open={showMessage} message={message} messageType={messageType} handleClose={() => setShowMessage(false)} />
    </Box>
  )
}

const mapDispatchToProps = (dispatch) => ({
  getProgramById: (payload) => dispatch(getProgramById(payload)),
})

const mapStateToProps = ({ programs, auth }) => {
  const { currentUser, isAdmin, accountId, isViewOnly, isSuperAdmin } = auth
  const { programDetails } = programs
  return { currentUser, isAdmin, programDetails, accountId, isViewOnly, isSuperAdmin }
}

export default connect(mapStateToProps, mapDispatchToProps)(Vpp)